import React, { Component } from 'react'
import cn from 'classnames'
import MUIMenuItem from '@material-ui/core/MenuItem'
import { CheckBox, CheckBoxOutlineBlank } from '@material-ui/icons'
import './style.scss'

class MenuItem extends Component {
  getIcon = selected =>
    selected ? (
      <CheckBox className="mi-checkbox-icon mi-checked-icon" />
    ) : (
      <CheckBoxOutlineBlank className="mi-checkbox-icon mi-unchecked-icon" />
    )

  render() {
    const {
      withoutCheckIcon,
      defaultSelected,
      isPurpleStyle,
      ...restProps
    } = this.props
    const { selected, children } = restProps

    return (
      <MUIMenuItem
        classes={{
          root: isPurpleStyle ? 'muiovr-menu-item-purple' : 'muiovr-menu-item',
        }}
        className={cn({
          'with-icon': !withoutCheckIcon,
        })}
        {...restProps}>
        {!withoutCheckIcon && this.getIcon(selected || defaultSelected)}
        {children}
      </MUIMenuItem>
    )
  }
}

export default MenuItem
